<template>
  <div class="topNav">
    <!-- <div class="title">
      <img src="../assets/images/logo_white.png" alt="">
      {{leftData.title}}
    </div> -->
    <div class="navImage">
      <img :src="subBa" alt="">
    </div>
    <div class="navList">
      <template v-for="(item, index) in navs">
        <div :class="['item', 'fz20', activeName === item.name ? 'itemActive' : '']" :key="item.name"
          @click="changeTab(item)">
          {{ item.text }}
        </div>
        <div :key="item.name + index" class="navLine" v-if="index !== navs.length - 1"></div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'topNav',
  components: {},
  props: {
    leftData: {
      type: Object,
      required: () => { }
    },
    activeNav: {
      type: String,
      required: ''
    }
  },
  data() {
    return {
      subBa: ''
    }
  },
  watch: {
    leftData: {
      deep: true,
      handler(val) {
        this.navs = val.navs
      }
    },
    activeNav(val) {
      this.activeName = val
      this.subBa = this.navs.find(item => item.name === val).subBa
    }
  },
  computed: {},
  created() {
    this.navs = this.leftData.navs
    this.activeName = this.$route.params.pathId
    this.subBa = this.navs.find(item => item.name === this.$route.params.pathId).subBa
  },
  mounted() { },
  methods: {
    changeTab(item) {
      if (this.activeName === item.name) return
      this.activeName = item.name
      this.$router.push({
        path: `/${item.fatherPath}/${item.name}`
      })
      this.$forceUpdate()
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.topNav {
  width: 100%;
  margin-right: 20px;

  .navImage {
    img {
      width: 100%;
      height: 27.8vw;
      min-width: 1200px;
      min-height: 400px;
    }
  }

  .navList {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 1200px;
    height: 104px;
    margin: 0 auto;
    padding: 0 40px;
    background: #FFFFFF;
    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.1);
    position: relative;
    top: -54px;
  }

  .navLine {
    width: 1px;
    height: 16px;
    background: #AAAAAA;
  }

  .item {
    height: 60px;
    line-height: 60px;
    background-color: #ffffff;
    padding: 0 20px;
    cursor: pointer;
  }

  .itemActive {
    color: #2488CA;
  }
}
</style>